<template>
  <button :class="['x-button', props.class]" :theme="theme">
    <slot />
  </button>
</template>
<script lang="ts" setup>
export interface IXButtonProps {
  theme: 'blank-primary' | string;
  class?: string;
}

const props = withDefaults(defineProps<IXButtonProps>(), {});
</script>

<style lang="scss" scoped>
.x-button {
  &[theme^='blank-'] {
    width: 100%;
    border: none;
    display: flex;
    height: m-rem(40);
    font-size: m-rem(16);
    border-radius: m-rem(8);
    justify-content: center;
    align-items: center;
    margin-top: m-rem(16);
  }

  &[theme='blank-primary'] {
    background-color: var(--primary-color);
    color: var(--text-0);
  }

  &[theme='blank-default'] {
    background-color: var(--text-0);
    border: 1px solid var(--primary-color);
    color: var(--primary-color);
  }
}
</style>
